import React from "react";
import { useLocation } from "react-router-dom";
import "./mobile-contact-bar.css";

export const WHATSAPP_NUMBER = "18764482032";
export const CALL_NUMBER = "+18766484163";

/** A WhatsApp link with a pre-filled message. */
export function whatsappLink(message: string) {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}

// Pages where a sticky bar would get in the way: staff pages, checkout and
// payment steps, and sign-in forms.
const HIDDEN = /^\/(admin|checkout|payment|login|register|forgot-password|reset-password)(\/|$)/;

/**
 * WhatsApp and Call buttons fixed to the bottom of the screen on phones. The
 * WhatsApp message names the page the customer is on, so staff know what
 * they are asking about. Hidden on larger screens by CSS.
 */
export default function MobileContactBar() {
  const { pathname } = useLocation();
  if (HIDDEN.test(pathname)) return null;
  const page = `https://technogeniousja.com${pathname === "/" ? "" : pathname}`;
  return (
    <nav className="mobile-contact-bar" aria-label="Contact Technogenious">
      <a className="mcb-whatsapp" href={whatsappLink(`Hello Technogenious, I have a question. I'm looking at ${page}`)} target="_blank" rel="noopener noreferrer">WhatsApp us</a>
      <a className="mcb-call" href={`tel:${CALL_NUMBER}`}>Call</a>
    </nav>
  );
}
